<template>
  <div v-if="!isRippleAdmin && developerMode == false">
    <base-header type="pattern" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row"> <!-- FIRST ROW -->
        <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-4"> <!-- COLUMN 1-->
          <div class="row"> <!-- row 1 -->
            <div class="col">
              <a-spin :spinning="spinner.month_to_date_sales">
                <stats-card title="SALES Month-to-Date" type="gradient-green" :sub-title="dashboard.total_month_to_date_sales"
                  icon="fa-sharp fa-solid fa-rotate-right" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
            </div>
          </div> <!-- end of row 1 -->
          <div class="row mt-4"> <!-- row 2 -->
            <div class="col">
              <!-- <a-spin :spinning="spinner.month_to_date_profit">
                <stats-card title="PROFIT Month-to-Date" type="gradient-green" :sub-title="dashboard.total_month_to_date_profit"
                  icon="fa-solid fa-money-bill" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin> -->
            </div>
          </div> <!-- end of row 2 -->
          <div class="row mt-4"> <!-- row 3 -->
            <div class="col">
              <a-spin :spinning="spinner.averageBasketSize">
                <stats-card type="gradient-green" icon="fa-solid fa-shopping-basket" class="mb-4 mb-xl-0">
                  <h2 class="card-title text-uppercase text-muted h5 mb-0">Average Basket Size</h2>
                  <p class="font-weight-bold h2">{{ averageBasketSize }}</p>
                </stats-card>
              </a-spin>
            </div>
          </div> <!-- end of row 3 -->
        </div> <!-- END OF COLUMN 1-->

        <!-- GRAPH-->
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4"> <!-- COLUMN 2-->
          <a-spin :spinning="spinner.line_sales">
            <card header-classes="bg-transparent">
              <canvas id="myChart" width="100%" height="50%"></canvas>
            </card>
          </a-spin>
        </div> <!-- END OF COLUMN 2-->
        <!-- END OF GRAPH-->

        <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-4"> <!-- COLUMN 3-->
          <div class="row"> <!-- row 1 -->
            <div class="col">
              <a-spin :spinning="spinner.sales">
                <stats-card title="SALES TODAY" type="gradient-green" :sub-title="dashboard.total_sales"
                icon="fas fa-shopping-cart" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
              <br>
            </div>
          </div> <!-- end of row 1 -->
          <div class="row mt-4"> <!-- row 2 -->
            <div class="col">
              <a-spin :spinning="spinner.last7days_sales">
                <stats-card title="SALES AVE. Past 7 days" type="gradient-green" :sub-title="dashboard.total_last7days_sales"
                icon="fa-solid fa-7" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
              <br>
            </div>
          </div> <!-- end of row 2 -->
        </div> <!-- END OF COLUMN 3-->

        <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2 mb-4"> <!-- COLUMN 4-->
          <div class="row"> <!-- row 1 -->
            <div class="col">
              <a-spin :spinning="spinner.yesterday_sales">
                <stats-card title="SALES YESTERDAY" type="gradient-green" :sub-title="dashboard.total_yesterday_sales"
                icon="fa-solid fa-backward" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
              <br>
            </div>
          </div> <!-- end of row 1 -->
          <div class="row mt-4"> <!-- row 2 -->
            <div class="col">
              <a-spin :spinning="spinner.month_ave_sales">
                <stats-card title="SALES AVE. MONTH" type="gradient-green" :sub-title="dashboard.total_month_ave_sales"
                icon="fa-solid fa-gauge-simple" class="mb-4 mb-xl-0">
                </stats-card>
              </a-spin>
              <br>
            </div>
          </div> <!-- end of row 2 -->
        </div> <!-- END OF COLUMN 4-->
      </div> <!-- END OF FIRST ROW -->

      <div class="row"> <!-- SECOND ROW -->
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4"> <!-- COLUMN 1-->
          <div class="card">
            <div class="p-3 pb-0 card-header">
              <div class="d-flex justify-content-between">
                <h4 class="mb-2">TOP SKUs</h4>
              </div>
            </div>
            <a-spin :spinning="spinner.top_items">
              <div class="table-responsive">
                <table class="table align-items-center">
                  <tbody>
                    <tr>
                      <td>
                        <div class="text-center col">
                          <p class="mb-0 text-xs font-weight-bold">#</p>
                        </div>
                      </td>

                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Barcode</p>
                        </div>
                      </td>
                      
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Name</p>
                        </div>
                      </td>

                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Quantity</p>
                        </div>
                      </td>
                      
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Sales</p>
                        </div>
                      </td>

                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Onhand Qty.</p>
                        </div>
                      </td>
                    </tr>
                    <tr v-for="item in dashboard.top_items" :key="item.row_number">
                      <td>
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm">{{ item.row_number }}</h6>
                        </div>
                      </td>
                      
                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm">{{ item.barcode }}</h6>
                        </div>
                      </td>

                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm">{{ item.product_name }}</h6>
                        </div>
                      </td>
                      
                      <td>
                        <div class="text-right">
                          <h6 class="mb-0 text-sm">{{ convertToCurrency(Number(item.quantity)) }}</h6>
                        </div>
                      </td>

                      <td>
                        <div class="text-right">
                          <h6 class="mb-0 text-sm">{{ convertToCurrency(Number(item.amount)) }}</h6>
                        </div>
                      </td>

                      <td>
                        <div class="text-right">
                          <h6 class="mb-0 text-sm">{{ convertToCurrency(Number(item.onhand_quantity)) }}</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> <!-- div class="table-responsive" -->
            </a-spin>
          </div> <!-- div class="card" -->
        </div> <!-- END OF COLUMN 1-->

        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4"> <!-- COLUMN 2-->
          <div class="card">
            <div class="p-3 pb-0 card-header">
              <div class="d-flex justify-content-between">
                <h4 class="mb-2">TOP Branches</h4>
              </div>
            </div>
            <a-spin :spinning="spinner.top_sites">
              <div class="table-responsive">
                <table class="table align-items-center">
                  <tbody>
                    <tr>
                      <td>
                        <div class="text-center col">
                          <p class="mb-0 text-xs font-weight-bold">#</p>
                        </div>
                      </td>

                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Code</p>
                        </div>
                      </td>
                      
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Name</p>
                        </div>
                      </td>
                      
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Sales</p>
                        </div>
                      </td>
                    </tr>
                    <tr v-for="site in dashboard.top_sites" :key="site.row_number">
                      <td>
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm">{{ site.row_number }}</h6>
                        </div>
                      </td>
                      
                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm">{{ site.refcode }}</h6>
                        </div>
                      </td>

                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm">{{ site.name }}</h6>
                        </div>
                      </td>
                      
                      <td>
                        <div class="text-right">
                          <h6 class="mb-0 text-sm">{{ convertToCurrency(Number(site.amount)) }}</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> <!-- div class="table-responsive" -->
            </a-spin>
          </div> <!-- div class="card" -->
        </div> <!-- END OF COLUMN 2-->
      </div> <!-- END OF SECOND ROW -->
      <!-- End of Card stats -->
    </base-header>
  </div> <!-- end condition for user type-->
</template>
  
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import secureStorage from '../controllers/secureStorage.js'
  import HTTPRequest from '../controllers/httpRequest.js'
  import moment from 'moment';

  var Chart = require('chart.js');
  var myChart
  var component_x
  import {
    mapState, mapActions
  } from 'vuex'

  export default {
    computed: {
      ...mapState(['loggedIn', 'endPoint', 'serverType']),
    },
    data() {
      return {
        developerMode: secureStorage.getItem("developerMode"),
        site_type: 'ho',
        dashboard: {
          total_sales: "0",
          total_last7days_sales: "0",
          total_yesterday_sales: "0",
          total_month_to_date_sales: "0",
          total_month_to_date_profit: "0",
          total_last7_sales: "0",
          total_month_ave_sales: "0",
          top_items: [],
          top_sites: []
        },
        spinner: {
          sales: false,
          month_to_date_sales: false,
          month_to_date_profit: false,
          last7days_sales: false,
          yesterday_sales: false,
          month_ave_sales: false,
          top_items: false,
          top_sites: false,
          line_sales: false,
          averageBasketSize: false
        },
        averageBasketSize: 0,
        chartOptions: {
          type: 'line',
          data: {
            labels: ['Feb 22', 'Feb 23', 'Feb 24', 'Feb 25', 'Feb 26', 'Feb 27', 'Feb 28'],
            datasets: [{
              label: 'Sales',
              data: [1, 1, 1, 1, 1, 1, 1],
              backgroundColor: '#2dce89',
              borderColor: 'rgba(255, 99, 132, 1)',
              borderWidth: 1
            }]
          },
          options: {}
        },
        isRippleAdmin: secureStorage.getItem("isRippleAdmin"),
        developerMode: secureStorage.getItem("developerMode")
      };
    },
    mounted: async function () {
      component_x = this

      if (this.loggedIn == false && this.developerMode == false) {
        this.$router.push('/')
      } else {
        Object.assign(component_x.spinner, {
          sales: true,
          month_to_date_sales: true,
          month_to_date_profit: true,
          last7days_sales: true,
          yesterday_sales: true,
          month_ave_sales: true,
          top_items: true,
          top_sites: true,
          line_sales: true,
          averageBasketSize: true
        })

        let siteId = secureStorage.getItem("defaultSiteId")
        let siteConceptId = secureStorage.getItem("defaultSiteConceptId")
        console.log(siteId)
        let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
        if(site != undefined){
            component_x.site_type = site.site_type
        }

        const current_date = new Date().setDate(new Date().getDate());
        const prevday7 = new Date(new Date().setDate(new Date().getDate()-7));
        const prevday6 = new Date(new Date().setDate(new Date().getDate()-6));
        const prevday5 = new Date(new Date().setDate(new Date().getDate()-5));
        const prevday4 = new Date(new Date().setDate(new Date().getDate()-4));
        const prevday3 = new Date(new Date().setDate(new Date().getDate()-3));
        const prevday2 = new Date(new Date().setDate(new Date().getDate()-2));
        const yesterday = new Date(new Date().setDate(new Date().getDate()-1));

        let formatted_current_date = moment(current_date).format('YYYY-MM-DD');
        let formatted_firstDay = moment().startOf('month').format('YYYY-MM-DD');
        let formatted_yesterday= moment(yesterday).format('YYYY-MM-DD');
        let formatted_prev2 = moment(prevday2).format('YYYY-MM-DD');
        let formatted_prev3 = moment(prevday3).format('YYYY-MM-DD');
        let formatted_prev4 = moment(prevday4).format('YYYY-MM-DD');
        let formatted_prev5 = moment(prevday5).format('YYYY-MM-DD');
        let formatted_prev6 = moment(prevday6).format('YYYY-MM-DD');
        let formatted_prev7 = moment(prevday7).format('YYYY-MM-DD');

        let formatted_label_yesterday = moment(yesterday).format('MMM DD');
        let formatted_label_prev2 = moment(prevday2).format('MMM DD');
        let formatted_label_prev3 = moment(prevday3).format('MMM DD');
        let formatted_label_prev4 = moment(prevday4).format('MMM DD');
        let formatted_label_prev5 = moment(prevday5).format('MMM DD');
        let formatted_label_prev6 = moment(prevday6).format('MMM DD');
        let formatted_label_prev7 = moment(prevday7).format('MMM DD');

        // month to date sales
        let month_to_date_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          month_to_date_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        } else {
          month_to_date_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        }

        if(month_to_date_sales_data != undefined){
          let total_month_to_date_sales = component_x.convertToCurrency(Number(month_to_date_sales_data.total_sales) - Number(month_to_date_sales_data.total_returns))
          
          Object.assign(component_x.dashboard, {
            total_month_to_date_sales: total_month_to_date_sales
          })
        }
        component_x.spinner.month_to_date_sales = false
        // end of month to date sales

        // month to date profit
        let month_to_date_profit_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          month_to_date_profit_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_profit_summary?site_id=' + siteId + '&date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        } else {
          month_to_date_profit_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_profit_summary?date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        }

        if(month_to_date_profit_data != undefined){
          let total_month_to_date_profit = component_x.convertToCurrency(Number(month_to_date_profit_data.total_sales) - Number(month_to_date_profit_data.total_returns))

          Object.assign(component_x.dashboard, {
            total_month_to_date_profit: total_month_to_date_profit
          })
        }
        component_x.spinner.month_to_date_profit = false
        // end of month to date profit

        //basket
        let month_to_date_basket_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          month_to_date_basket_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/get_average_basket_size?site_id=' + siteId + '&date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        } else {
          month_to_date_basket_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/get_average_basket_size?date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        }
        if (month_to_date_basket_data != undefined){
            this.averageBasketSize = component_x.convertToCurrency(Number(month_to_date_basket_data.average_basket_size))
        } 
        component_x.spinner.averageBasketSize = false
        //end of basket

        // yesterday sales
        let yesterday_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          yesterday_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_yesterday + '&date_to=' + formatted_yesterday, null)
        } else {
          yesterday_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_yesterday + '&date_to=' + formatted_yesterday, null)
        }
        let total_yesterday_sales = 0
        if(yesterday_sales_data != undefined){
          total_yesterday_sales = Number(yesterday_sales_data.total_sales) - Number(yesterday_sales_data.total_returns)

          Object.assign(component_x.dashboard, {
            total_yesterday_sales: component_x.convertToCurrency(total_yesterday_sales)
          })
        }
        // end of yesterday sales

        // line graph
        let prev2_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          prev2_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_prev2 + '&date_to=' + formatted_prev2, null)
        } else {
          prev2_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_prev2 + '&date_to=' + formatted_prev2, null)
        }
        let prev2_sales = 0
        if(prev2_sales_data != undefined){
          prev2_sales = Number(prev2_sales_data.total_sales) - Number(prev2_sales_data.total_returns)
        }

        let prev3_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          prev3_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_prev3 + '&date_to=' + formatted_prev3, null)
        } else {
          prev3_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_prev3 + '&date_to=' + formatted_prev3, null)
        }
        let prev3_sales = 0
        if(prev3_sales_data != undefined){
          prev3_sales = Number(prev3_sales_data.total_sales) - Number(prev3_sales_data.total_returns)
        }

        let prev4_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          prev4_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_prev4 + '&date_to=' + formatted_prev4, null)
        } else {
          prev4_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_prev4 + '&date_to=' + formatted_prev4, null)
        }
        let prev4_sales = 0
        if(prev4_sales_data != undefined){
          prev4_sales = Number(prev4_sales_data.total_sales) - Number(prev4_sales_data.total_returns)
        }

        let prev5_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          prev5_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_prev5 + '&date_to=' + formatted_prev5, null)
        } else {
          prev5_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_prev5 + '&date_to=' + formatted_prev5, null)
        }
        let prev5_sales = 0
        if(prev5_sales_data != undefined){
          prev5_sales = Number(prev5_sales_data.total_sales) - Number(prev5_sales_data.total_returns)
        }

        let prev6_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          prev6_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_prev6 + '&date_to=' + formatted_prev6, null)
        } else {
          prev6_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_prev6 + '&date_to=' + formatted_prev6, null)
        }
        let prev6_sales = 0
        if(prev6_sales_data != undefined){
          prev6_sales = Number(prev6_sales_data.total_sales) - Number(prev6_sales_data.total_returns)
        }

        let prev7_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          prev7_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_prev7 + '&date_to=' + formatted_prev7, null)
        } else {
          prev7_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_prev7 + '&date_to=' + formatted_prev7, null)
        }
        let prev7_sales = 0
        if(prev7_sales_data != undefined){
          prev7_sales = Number(prev7_sales_data.total_sales) - Number(prev7_sales_data.total_returns)
        }
        
        component_x.chartOptions.data.labels = [formatted_label_prev7, formatted_label_prev6, formatted_label_prev5, formatted_label_prev4, formatted_label_prev3, formatted_label_prev2, formatted_label_yesterday]
        component_x.chartOptions.data.datasets[0].data = [prev7_sales, prev6_sales, prev5_sales, prev4_sales, prev3_sales, prev2_sales, total_yesterday_sales]
        myChart = new Chart("myChart", component_x.chartOptions);
        component_x.spinner.line_sales = false
        // end of line graph

        // sales for the day
        let sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/pos_document_summary?site_id=' + siteId, null)
        } else {
          sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/pos_document_summary', null)
        }

        if(sales_data != undefined){
          let total_sales = component_x.convertToCurrency(Number(sales_data.total_sales) - Number(sales_data.total_returns))

          Object.assign(component_x.dashboard, {
            total_sales: total_sales
          })
        }
        component_x.spinner.sales = false
        // end of sales for the day

        // last 7 days sales
        let last7days_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          last7days_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_prev7 + '&date_to=' + formatted_yesterday, null)
        } else {
          last7days_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_prev7 + '&date_to=' + formatted_yesterday, null)
        }
        let total_last7days_sales = 0
        if(last7days_sales_data != undefined){
          total_last7days_sales = Number(last7days_sales_data.total_sales) - Number(last7days_sales_data.total_returns)
          let ave7days = 0
          if (total_last7days_sales != 0){
            ave7days = (total_last7days_sales / 7)
          }
          
          Object.assign(component_x.dashboard, {
            total_last7days_sales: component_x.convertToCurrency(ave7days)
          })
        }
        component_x.spinner.last7days_sales = false
        // end of last 7 days sales

        // spinner for yesterday
        component_x.spinner.yesterday_sales = false

        // average month to yesterday sales
        let month_ave_sales_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          month_ave_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?site_id=' + siteId + '&date_from=' + formatted_firstDay + '&date_to=' + formatted_yesterday, null)
        } else {
          month_ave_sales_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_summary?date_from=' + formatted_firstDay + '&date_to=' + formatted_yesterday, null)
        }

        if(month_ave_sales_data != undefined){
          let total_month_ave_sales = Number(month_ave_sales_data.total_sales) - Number(month_ave_sales_data.total_returns)
          let ave_month_days = 0
          let day_to_denom = Number(moment(yesterday).format('D'));
          if (total_month_ave_sales != 0){
            ave_month_days = (total_month_ave_sales / day_to_denom)
          }
          
          Object.assign(component_x.dashboard, {
            total_month_ave_sales: component_x.convertToCurrency(ave_month_days)
          })
        }
        component_x.spinner.month_ave_sales = false
        // end of average month to yesterday sales

        let top_items_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          top_items_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_top_item_sales?top=10&site_id=' + siteId + '&date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        } else {
          top_items_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_top_item_sales?top=10&date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        }

        if(top_items_data != undefined){
          Object.assign(component_x.dashboard, {
            top_items: top_items_data
          })
        }
        component_x.spinner.top_items = false

        // top branches
        let top_sites_data = []
        if(['branch','BRANCH','Branch'].includes(component_x.site_type)){
          top_sites_data = top_sites_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_top_site_sales?top=10&site_concept_id='+siteConceptId+'&date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        } else {
          top_sites_data = top_sites_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_documents/range_top_site_sales?top=10&date_from=' + formatted_firstDay + '&date_to=' + formatted_current_date, null)
        }
        if(top_sites_data != undefined){
          Object.assign(component_x.dashboard, {
            top_sites: top_sites_data
          })
        }
        component_x.spinner.top_sites = false
        // end of top branches
      }
    },
    methods: {
      ...mapActions(['updateCurrentProfile']),
      moment,
      convertToCurrency(num){
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      setCurrentProfile(profile) {
        this.updateCurrentProfile(profile);
      },
    }
  };
</script>
<style lang='scss'>
  @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
  .tabulator-group-toggle{
    display: none;
  }
  .ant-spin-nested-loading,
  .ant-spin-container{
    height: 100%;
  }

  .active-terminals{
    font-size: 20px;
  }
  </style>
  